<health-data-page
    [chartLabel]="chartLabel"
    [healthDataLabel]="healthDataLabel"
    [healthDataType]="heartRateHealthDataType"
    [hasTwoDecimals]="hasTwoDecimals"
    [payloadTypes]="payloadTypes"
/>
